import React from "react";
import { Outlet, Link, useNavigate } from "react-router-dom";
import logo from '../assets/Images/ZingLogo_smol2.jpg';
import '../assets/CSS/Layout.css';
import UserSearch from "./UserSearch"; 


function Layout() {
  const user = JSON.parse(localStorage.getItem("loggedInUser"));
  const navigate = useNavigate();

  //logg ut funkjsonen 
  const handleLogout = () => {
    localStorage.removeItem("loggedInUser");
    navigate("/login")
  };

  return (
    <div id="layout">
      {/* Topbar */}
      <div className="topbar">
        <div className="logo">
          <Link to="/feed">   
          <img src={logo} alt="Zing Logo"/>
          </Link>
        </div>

        <UserSearch />

        <ul className="navbar">
          <li><Link to="/feed">Home</Link></li>
          <li><Link to="/messages">Messages</Link></li>
          <li>
            <Link to={`/profile/${user?.id}`}>
              {user ? `${user.firstName} ` : "Profil"}
            </Link>
          </li>
          <li>
            <a
            href="/login"
            onClick={() => {
              localStorage.removeItem("loggedInUser");
            }}
          >
            Log out
            </a>
          </li>
        </ul>
      </div>

      <main className="content">
        <Outlet />
      </main>
    </div>
  );
}

export default Layout;